import { Action, handleActions } from 'redux-actions'
import {
  Gender,
  Lang,
  OnboardingStatus,
  Role,
  ServiceProvider,
  Units,
  UserCompanyDto,
  UserCompanyRolesDto,
  UserProfileDto,
  WhoAmI$Response,
} from '../../services/api.types'
import { getWhoAmISuccess, setOnboardingStatusProfileData } from './authActions'

const userDtoDefault: UserProfileDto = {
  active: true,
  createdAt: 0,
  dateOfBirth: '',
  country: '',
  email: '',
  firstName: '',
  gender: Gender.MALE,
  height: 0,
  lang: Lang.EN,
  lastName: '',
  onboardingStatus: OnboardingStatus.DONE,
  //role: Role.ANONYMOUS,
  userId: '',
  serviceProvider: ServiceProvider.YUMUUV, //ServiceProvider.GOOGLE_FIT,
  weight: 0,
  lastSync: 0,
  googleId: '',
  timeZone: '',
  units: Units.METRIC,
  appleId: '',
  integrationError: '',
  newsletterSubscriber: false,
  passwordSet: false,
}

class State {
  authenticated = false
  resetPasswordInProgress = false
  userDto: UserProfileDto = userDtoDefault
  userCompanies: UserCompanyDto[] = []
  userCompanyRoles: UserCompanyRolesDto[] = []
  managedCompanies: UserCompanyDto[] = []
  userIntegrationScopes = ''
}

export const auth = handleActions<State, WhoAmI$Response>(
  {
    [String(getWhoAmISuccess)]: (
      state: State,
      {
        payload: {
          authenticated,
          resetPasswordInProgress,
          userDto,
          userCompanies,
          userCompanyRoles,
          userIntegrationScopes,
        },
      }: Action<any>,
    ): State => ({
      ...state,
      authenticated,
      resetPasswordInProgress,
      userIntegrationScopes,
      userDto: userDto || userDtoDefault,
      userCompanies: userCompanies || [],
      userCompanyRoles: userCompanyRoles || [],
      managedCompanies:
        (userCompanies &&
          userCompanyRoles &&
          userCompanies.filter((userCompany: UserCompanyDto) =>
            userCompanyRoles.some(
              (companyRole: { companyId: string; roles: any[] }) =>
                companyRole.companyId === userCompany.companyId &&
                companyRole.roles.some((role) => role === Role.ADMIN),
            ),
          )) ||
        [],
    }),
    [String(setOnboardingStatusProfileData)]: (state: State): State => ({
      ...state,
      userDto: {
        ...state.userDto,
        onboardingStatus: OnboardingStatus.PROFILE_DATA,
        serviceProvider: ServiceProvider.APPLE_HEALTH,
      },
    }),
  },
  new State(),
)

export { State as AuthState }
